export const API_ENDPOINT = 'https://zipa-api.novamedia.agency'
// export const API_ENDPOINT = 'http://localhost:37503'